import { render, staticRenderFns } from "./AddTrip.vue?vue&type=template&id=454ec793"
import script from "./AddTrip.vue?vue&type=script&lang=js"
export * from "./AddTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports